import { render, staticRenderFns } from "./Staging-New-360-Request-Step1.vue?vue&type=template&id=0bf82c55&scoped=true&"
import script from "./Staging-New-360-Request-Step1.vue?vue&type=script&lang=js&"
export * from "./Staging-New-360-Request-Step1.vue?vue&type=script&lang=js&"
import style0 from "./Staging-New-360-Request-Step1.vue?vue&type=style&index=0&id=0bf82c55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf82c55",
  null
  
)

export default component.exports